<template>
  <div class="dashboard">
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'jp' }})">
      <span class="flag-icon flag-icon-jp"></span>
      <div><strong>นิเคอิ</strong></div>
    </div>
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'cn' }})">
      <span class="flag-icon flag-icon-cn"></span>
      <div><strong>จีน</strong></div>
    </div>
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'hk' }})">
      <span class="flag-icon flag-icon-hk"></span>
      <div><strong>ฮั่งเส็ง</strong></div>
    </div>
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'tw' }})">
      <span class="flag-icon flag-icon-tw"></span>
      <div><strong>ไต้หวัน</strong></div>
    </div>
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'kr' }})">
      <span class="flag-icon flag-icon-kr"></span>
      <div><strong>เกาหลี</strong></div>
    </div>
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'sg' }})">
      <span class="flag-icon flag-icon-sg"></span>
      <div><strong>สิงคโปร์</strong></div>
    </div>
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'in' }})">
      <span class="flag-icon flag-icon-in"></span>
      <div><strong>อินเดีย</strong></div>
    </div>
  </div>
</template>
<script>
//import moment from '@/moment.js'

export default {
  mounted() {
    //console.log('moment', moment().format("YYYY-MM-DD HH:mm:ss"));
    //console.log('moment', moment().diff("2020-12-20 16:00:00", "minutes"));
  }
}
</script>
<style lang="scss">
.dashboard {
  display: flex;
  flex-direction: 'row';
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  .l-list {
    flex: 0.2;
    margin: 4px;
    padding: 15px;
    border:1px solid #00308E;
    text-align: center;
    cursor: pointer;
    background-color: #FFF;
    .flag-icon {
      font-size: 120px;
      border:1px solid #eee;
      margin-bottom: 10px;
    }
    strong {
      color: #00308E;
    }
  }
}
</style>
